// extracted by mini-css-extract-plugin
export default {"info":"IoU3S","manual":"mfbEU","counter":"IQBjk","selection":"Gm726","dance":"OkJI4","playing":"FWu5h","stop":"wQZcu","header":"MwBtv"};